export default {
  computed: {
    $typeGuideAccountType() {
      return [
        { value: null, text: "Select an Account Type" },
        { value: "Listed", text: "Listed", disabled: true },
        { value: "Unlisted", text: "Unlisted", disabled: true },
        { value: "Invite", text: "Invite" }
      ];
    }
  }
};
